import "./Reviews.scss";
import React from "react";

export default function Reviews() {
  return (
    <section className="reviews">
      <div className="reviews__inner">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
      </div>
    </section>
  );
}
